<template>
    <div class="w-100">
        <v-flex xs12 class="mb-4" v-if="conditions.length">
            <draggable v-model="conditions" @start="drag=true" @end="drag=false" class="draggable-row">
                <v-layout
                    class="ma-0 pa-0 mb-1 w-100"
                    v-for="(condition, indexCondition) in conditions"
                    :key="`condition${indexCondition}`"
                    column
                >
                    <v-flex xs12 d-flex align-center v-if="condition">
                        <div class="close-btn mr-1" style="width: 20px; max-width: 25px">
                            <v-img max-height="18px" max-width="18px" :src="require('@/assets/icons/draggable.svg')" class="d-inline-flex"/>
                        </div>
                        <v-flex class="d-inline-flex mr-1" style="width: 25px; max-width: 25px">
                            {{indexCondition + 1}}.
                        </v-flex>
                        <div
                            class="condition-line"
                            :class="condition.type == 5 ? 'oper-block grey-text' : ''"
                            :style="{'padding-left': `${checkStep(indexCondition)}px`}"
                            v-if="condition"
                            :key="indexCondition"
                        >
                            <div class="d-inline-flex" v-if="condition.type == 1 && condition.device">
                                {{condition.device.name}}
                                <span v-if="condition.device.location" class="mx-1">({{ condition.device.location }})</span>
                                -
                            </div>
                            <div class="d-inline-flex" v-if="condition.type == 2 && condition.scenario">
                                {{condition.scenario.name}}
                                <span v-if="condition.scenario.location" class="mx-1">({{ condition.scenario.location }})</span>
                                -
                            </div>
                            <div v-if="condition.variable" class="d-inline-flex ml-1">{{condition.variable.name}}</div>
                            <div v-if="condition.comparison_operator" class="d-inline-flex mx-1 comparisons">
                                <v-img
                                    max-height="18px"
                                    max-width="18px"
                                    :src="require(`@/assets/icons/comparison/${comparisons[condition.comparison_operator].icon}.svg`)"
                                    class="d-inline-flex"
                                />
                            </div>
                            <div v-if="condition.state" class="d-inline-flex ml-1">{{condition.state.name}}</div>
                            <div
                                v-else-if="
                                    condition.device && condition.device.device_type == 12 &&
                                     condition.variable && condition.variable.value_type == 'select'
                                "
                                class="d-inline-flex ml-1"
                            >
                                Выкл
                            </div>
                            <div v-if="condition.number" class="d-inline-flex ml-1">{{condition.number}}</div>
                            <div class="d-inline-flex" v-if="condition.type == 3 && condition.oper">
                                {{condition.oper.name}}
                            </div>
                            <div class="d-inline-flex" v-if="condition.type == 5 && condition.oper" @click="switchOper(indexCondition)">
                                {{condition.oper.name}}
                            </div>
                            <div class="d-inline-flex" v-if="condition.type == 4 && condition.time">
                                {{condition.time}}
                            </div>
                        </div>
                        <div v-if="condition.type != 5" class="close-btn mx-2" @click="editCondition(condition)">
                            <v-img max-height="18px" max-width="18px" :src="require('@/assets/icons/edit_icon.svg')" class="d-inline-flex"/>
                        </div>
                        <div v-if="condition.type != 5" class="close-btn" @click="removeCondition(indexCondition)">
                            <v-img max-height="18px" :src="require('@/assets/icons/close_icon.svg')" class="d-inline-flex"/>
                        </div>
                    </v-flex>
                </v-layout>
            </draggable>
        </v-flex>
        <v-flex xs12 class="mb-2" v-if="showConditionForm">
            <v-layout row class="condition-form">
                <v-flex xs12 class="d-inline-flex">
                    <v-select
                        v-model="type"
                        placeholder="Тип условия"
                        class="input-form-grey scenario-action"
                        :items="conditionsValues"
                        item-text="name"
                        item-value="value"
                        :menu-props="{
                            bottom: true,
                            offsetY: true,
                            closeOnContentClick: true,
                        }"
                        @change="updateType"
                    >
                        <template #item="{item}">
                            <v-flex class="menu-item__scenario-action d-inline-flex align-center">
                                <v-img
                                    max-height="20px"
                                    max-width="20px"
                                    :src="require(`@/assets/scenario-form/${item.icon}_icon.svg`)"
                                    class="d-inline-flex mr-3"
                                />
                                {{item.name}}
                            </v-flex>
                        </template>
                        <template #selection="{item}">
                            <v-flex class="d-inline-flex align-center">
                                <v-img
                                    max-height="20px"
                                    max-width="20px"
                                    :src="require(`@/assets/scenario-form/${item.icon}_icon.svg`)"
                                    class="d-inline-flex mr-3"
                                />
                                {{item.name}}
                            </v-flex>
                        </template>
                        <template #no-data>
                            <v-flex style="padding: 10px 22px">Нет доступных элементов</v-flex>
                        </template>
                    </v-select>
                </v-flex>
                <v-flex xs12 v-if="type == 1">
                    <v-select
                        v-model="device"
                        placeholder="Устройство"
                        class="input-form-grey"
                        :items="devices"
                        item-value="uid"
                        :menu-props="{
                            bottom: true,
                            offsetY: true,
                            closeOnContentClick: true,
                        }"
                        return-object
                        @change="updateVariable"
                    >
                        <template #item="{item}">
                            <v-flex style="padding: 10px 22px">{{item.name}} - {{item.location}}</v-flex>
                        </template>
                        <template #selection="{item}">
                            <v-flex>{{item.name}} - {{item.location}}</v-flex>
                        </template>
                        <template #no-data>
                            <v-flex style="padding: 10px 22px">Нет доступных элементов</v-flex>
                        </template>
                    </v-select>
                </v-flex>
                <v-flex xs12 v-if="type == 2">
                    <v-select
                        v-model="scenario"
                        placeholder="Сценарий"
                        class="input-form-grey"
                        :items="scenarios"
                        item-value="uid"
                        :menu-props="{
                            bottom: true,
                            offsetY: true,
                            closeOnContentClick: true,
                        }"
                        return-object
                        @change="updateVariable"
                    >
                        <template #item="{item}">
                            <v-flex style="padding: 10px 22px">{{item.name}} - {{item.location}}</v-flex>
                        </template>
                        <template #selection="{item}">
                            <v-flex>{{item.name}} - {{item.location}}</v-flex>
                        </template>
                        <template #no-data>
                            <v-flex style="padding: 10px 22px">Нет доступных элементов</v-flex>
                        </template>
                    </v-select>
                </v-flex>
                <v-flex xs12 v-if="type == 3">
                    <v-select
                        v-model="operRadio"
                        placeholder="Оператор"
                        class="input-form-grey scenario-oper"
                        :items="operTypesSelect"
                        item-text="name"
                        item-value="value"
                        :menu-props="{
                            bottom: true,
                            offsetY: true,
                            closeOnContentClick: true,
                        }"
                        return-object
                    >
                        <template #item="{item}">
                            <v-flex class="menu-item__scenario-oper d-inline-flex align-center">{{item.name}}</v-flex>
                        </template>
                        <template #selection="{item}">
                            <v-flex>{{item.name}}</v-flex>
                        </template>
                        <template #no-data>
                            <v-flex style="padding: 10px 22px">Нет доступных элементов</v-flex>
                        </template>
                    </v-select>
                </v-flex>
                <v-flex xs12 class="d-flex" v-if="device && device.uid">
                    <v-select
                        v-if="available[`device_${device.device_type}`].length"
                        v-model="variable"
                        placeholder="Вариант"
                        class="input-form-grey scenario-state"
                        :items="available[`device_${device.device_type}`]"
                        item-text="name"
                        item-value="key"
                        :menu-props="{
                            bottom: true,
                            offsetY: true,
                            closeOnContentClick: true,
                        }"
                        return-object
                        :disabled="available[`device_${device.device_type}`].length == 1"
                        @change="updateState"
                    >
                        <template #item="{item}">
                            <v-flex class="menu-item__scenario-state d-inline-flex align-center">
<!--                                <v-img-->
<!--                                    max-height="20px"-->
<!--                                    max-width="20px"-->
<!--                                    :src="require(`@/assets/scenario-form/${item.key == 'run' ? 'run' : 'state'}_icon.svg`)"-->
<!--                                    class="d-inline-flex mr-3"-->
<!--                                />-->
                                {{item.name}}
                            </v-flex>
                        </template>
                        <template #selection="{item}">
                            <v-flex class="d-inline-flex align-center">
<!--                                <v-img-->
<!--                                    max-height="20px"-->
<!--                                    max-width="20px"-->
<!--                                    :src="require(`@/assets/scenario-form/${item.key == 'run' ? 'run' : 'state'}_icon.svg`)"-->
<!--                                    class="d-inline-flex mr-3"-->
<!--                                />-->
                                {{item.name}}
                            </v-flex>
                        </template>
                        <template #no-data>
                            <v-flex style="padding: 10px 22px">Нет доступных элементов</v-flex>
                        </template>
                    </v-select>
                    <div v-else class="red-text">
                        Нет доступных действий для этого устройства
                    </div>
                </v-flex>
                <v-flex xs12 class="d-flex" v-if="scenario && scenario.uid">
                    <v-select
                        v-if="available.scenario"
                        v-model="variable"
                        placeholder="Вариант"
                        class="input-form-grey scenario-state"
                        :items="available.scenario"
                        item-text="name"
                        item-value="key"
                        :menu-props="{
                            bottom: true,
                            offsetY: true,
                            closeOnContentClick: true,
                        }"
                        return-object
                        :disabled="available.scenario.length == 1"
                        @change="updateState"
                    >
                        <template #item="{item}">
                            <v-flex class="menu-item__scenario-state d-inline-flex align-center">
<!--                                <v-img-->
<!--                                    max-height="20px"-->
<!--                                    max-width="20px"-->
<!--                                    :src="require(`@/assets/scenario-form/${item.key == 'run' ? 'run' : 'state'}_icon.svg`)"-->
<!--                                    class="d-inline-flex mr-3"-->
<!--                                />-->
                                {{item.name}}
                            </v-flex>
                        </template>
                        <template #selection="{item}">
                            <v-flex class="d-inline-flex align-center">
<!--                                <v-img-->
<!--                                    max-height="20px"-->
<!--                                    max-width="20px"-->
<!--                                    :src="require(`@/assets/scenario-form/${item.key == 'run' ? 'run' : 'state'}_icon.svg`)"-->
<!--                                    class="d-inline-flex mr-3"-->
<!--                                />-->
                                {{item.name}}
                            </v-flex>
                        </template>
                        <template #no-data>
                            <v-flex style="padding: 10px 22px">Нет доступных элементов</v-flex>
                        </template>
                    </v-select>
                    <div v-else class="red-text">
                        Нет доступных действий для сценария
                    </div>
                </v-flex>
                <v-flex xs12 class="d-flex" v-if="type == 4 && available.time">
                    <v-select
                        v-model="variable"
                        placeholder="Вариант"
                        class="input-form-grey scenario-state"
                        :items="available.time"
                        item-text="name"
                        item-value="key"
                        :menu-props="{
                            bottom: true,
                            offsetY: true,
                            closeOnContentClick: true,
                        }"
                        return-object
                        :disabled="available.time.length == 1"
                        @change="updateState"
                    >
                        <template #item="{item}">
                            <v-flex class="menu-item__scenario-state d-inline-flex align-center">
<!--                                <v-img-->
<!--                                    max-height="20px"-->
<!--                                    max-width="20px"-->
<!--                                    :src="require(`@/assets/scenario-form/${item.key == 'run' ? 'run' : 'state'}_icon.svg`)"-->
<!--                                    class="d-inline-flex mr-3"-->
<!--                                />-->
                                {{item.name}}
                            </v-flex>
                        </template>
                        <template #selection="{item}">
                            <v-flex class="d-inline-flex align-center">
<!--                                <v-img-->
<!--                                    max-height="20px"-->
<!--                                    max-width="20px"-->
<!--                                    :src="require(`@/assets/scenario-form/${item.key == 'run' ? 'run' : 'state'}_icon.svg`)"-->
<!--                                    class="d-inline-flex mr-3"-->
<!--                                />-->
                                {{item.name}}
                            </v-flex>
                        </template>
                        <template #no-data>
                            <v-flex style="padding: 10px 22px">Нет доступных элементов</v-flex>
                        </template>
                    </v-select>
                </v-flex>
                <v-flex xs12 class="d-flex flex-column" v-if="variable">
                    <v-layout row ma-0 w-100 v-if="variable.comparison_operators.length > 1 || variable.value_type == 'time'">
                        <v-flex
                            :xs12="!(type == 4 && available.time)"
                            :xs6="type == 4 && available.time"
                            :pr-3="type == 4 && available.time"
                            v-if="variable.comparison_operators.length > 1"
                        >
                            <v-select
                                v-model="comparisonOperator"
                                placeholder="Оператор сравнения"
                                class="input-form-grey scenario-oper"
                                :items="variable.comparison_operators"
                                :menu-props="{
                                    bottom: true,
                                    offsetY: true,
                                    closeOnContentClick: true,
                                }"
                            >
                                <template v-slot:item="{ item }">
                                    <v-flex class="menu-item__scenario-oper d-inline-flex align-center">
                                        <v-img
                                            max-height="18px"
                                            max-width="18px"
                                            :src="require(`@/assets/icons/comparison/${comparisons[item].icon}.svg`)"
                                            class="d-inline-flex mr-3"
                                        />
                                        {{comparisons[item].name}}
                                    </v-flex>
                                </template>
                                <template v-slot:selection="{ item }">
                                    <v-img
                                        max-height="18px"
                                        max-width="18px"
                                        :src="require(`@/assets/icons/comparison/${comparisons[item].icon}.svg`)"
                                        class="d-inline-flex mr-3"
                                    />
                                    {{comparisons[item].name}}
                                </template>
                                <template #no-data>
                                    <v-flex style="padding: 10px 22px">Нет доступных элементов</v-flex>
                                </template>
                            </v-select>
                        </v-flex>
                        <v-flex xs6 v-if="variable.value_type == 'time'">
                            <v-text-field
                                v-model="time"
                                :placeholder="variable.name"
                                type="time"
                                class="input-picker-grey w-100"
                                style="max-width: 100%"
                                dense
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout row ma-0 w-100 v-if="variable.value_type == 'select'">
                        <v-select
                            v-model="state"
                            :placeholder="variable.name"
                            class="input-form-grey scenario-variable"
                            :items="variable.values"
                            item-text="name"
                            :menu-props="{
                                bottom: true,
                                offsetY: true,
                                closeOnContentClick: true,
                            }"
                            return-object
                        >
                            <template #item="{item}">
                                <v-flex class="menu-item__scenario-variable d-inline-flex align-center">{{item.name}}</v-flex>
                            </template>
                            <template #no-data>
                                <v-flex style="padding: 10px 22px">Нет доступных элементов</v-flex>
                            </template>
                        </v-select>
                    </v-layout>
                    <v-layout row ma-0 w-100 v-if="variable.value_type == 'int'">
                        <v-text-field
                            v-model="number"
                            :placeholder="variable.name"
                            class="input-form-grey error-field"
                            type="number"
                            min="0"
                            max="100"
                            :rules="rules.max"
                            @keypress="checkNumber($event)"
                        ></v-text-field>
                    </v-layout>
                </v-flex>
                <v-flex xs12 v-if="device && device.uid">
                    <v-checkbox
                        v-model="trigger"
                        label="Триггерное условие"
                        dense
                    ></v-checkbox>
                </v-flex>
                <v-flex xs12 class="d-flex justify-end">
                    <v-btn class="btn-grey main-text" @click="closeAddCondition">
                        Сбросить
                    </v-btn>
                    <v-btn class="btn-grey main-text ma-0" :disabled="disabledAdd" @click="addCondition">
                        Добавить
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex xs12 mb-4 v-if="!showConditionForm">
            <v-btn class="btn-light-grey" @click="openAddCondition">
                Добавить условие +
            </v-btn>
        </v-flex>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import {isNumber} from "@/utils";

export default {
    name: "ConditionsForm",
    components: {draggable},
    props: {
        conditionsData: {
            type: Array,
            default: () => [],
        },
        devices: {
            type: Array,
            default: () => [],
        },
        scenarios: {
            type: Array,
            default: () => [],
        },
        available: {
            type: Object,
            default: () => {},
        },
        edit: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            showConditionForm: false,
            type: null,
            operRadio: null,
            device: null,
            scenario: null,
            variable: null,
            state: null,
            number: null,
            time: null,
            trigger: null,
            comparisonOperator: null,
            editItem: null,
            comparisons: {
                "==": {
                    name: "Равно",
                    icon: "equal",
                },
                ">": {
                    name: "Больше",
                    icon: "more",
                },
                ">=": {
                    name: "Больше или равно",
                    icon: "more_equal",
                },
                "<": {
                    name: "Меньше",
                    icon: "less",
                },
                "<=": {
                    name: "Меньше или равно",
                    icon: "less_equal",
                },
                "!=": {
                    name: "Не равно",
                    icon: "not_equal",
                },
            },
            operTypes: [
                {
                    name: "или",
                    value: "or",
                },
                {
                    name: "и",
                    value: "and",
                },
            ],
            operTypesSelect: [
                {
                    name: "(",
                    value: "(",
                },
                {
                    name: ")",
                    value: ")",
                },
            ],
            conditionsValues: [
                {
                    name: "Устройство",
                    value: 1,
                    icon: "device",
                },
                {
                    name: "Сценарий",
                    value: 2,
                    icon: "scenario",
                },
                {
                    name: "Оператор",
                    value: 3,
                    icon: "oper",
                },
                {
                    name: "Время",
                    value: 4,
                    icon: "simple_clock",
                },
            ],
            conditions: [],
            rules: {
                max: [v => !!v && v < 101 || "Максимальное значение 100"],
            },
        };
    },
    computed: {
        disabledAdd() {
            return !this.type ||
                (this.type == 1 && !this.device) ||
                (this.type == 2 && !this.scenario) ||
                (this.type == 3 && !this.operRadio) ||
                (this.type != 3 && !this.variable) ||
                (this.variable && this.variable.value_type == 'time' && !this.time) ||
                (this.variable && this.variable.value_type == 'select' && !this.state) ||
                (this.variable && this.variable.value_type == 'int' && (!this.number || this.number > 100)) ||
                (this.variable && !this.comparisonOperator &&
                    (this.variable.comparison_operators.length > 1 || this.variable.value_type == "time"));
        },
    },
    watch: {
        edit(val) {
            if (val) {
                this.setConditionsEdit();
            }
        },
        device(val) {
            if (val) {
                if (this.available[`device_${val.device_type}`].length == 1) {
                    this.variable = this.available[`device_${val.device_type}`][0];
                }
            }
        },
        scenario(val) {
            if (val && this.available.scenario.length == 1) {
                this.variable = this.available.scenario[0];
            }
        },
        type(val) {
            if (val == 4 && this.available.time.length == 1) {
                this.variable = this.available.time[0];
            }
        },
    },
    methods: {
        setConditionsEdit() {
            this.conditions = [];
            this.edit.forEach((el) => {
                let condition = {};
                condition.type = el.type;
                if (condition.type == 1) {
                    condition.device = el.device;
                    if (el.trigger) {
                        condition.trigger = el.trigger;
                    }
                    let device_type = condition.device ? condition.device.device_type : "";
                    let availArr = this.available[`device_${device_type}`];
                    if (availArr) {
                        condition.variable = availArr.find((avail) => {
                            return avail.key == el.condition.field;
                        });
                        let value_type = condition.variable ? condition.variable.value_type : null;
                        if (value_type == "select") {
                            condition.state = condition.variable.values.find((val) => { return val.value === el.condition.value});
                        }
                        if (value_type == "int") {
                            condition.number = el.condition.value;
                        }
                        condition.comparison_operator = el.condition.comparison_operator;
                    }
                }
                if (condition.type == 2) {
                    condition.scenario = el.scenario;
                    let availArr = this.available.scenario;
                    if (availArr) {
                        condition.variable = availArr.find((avail) => {
                            return avail.key == el.condition.field;
                        });
                        let value_type = condition.variable ? condition.variable.value_type : null;
                        if (value_type == "select") {
                            condition.state = condition.variable.values.find((val) => { return val.value === el.condition.value});
                        }
                        if (value_type == "int") {
                            condition.number = el.condition.value;
                        }
                        condition.comparison_operator = el.condition.comparison_operator;
                    }
                }
                if (condition.type == 3 || condition.type == 5) {
                    condition.oper = this.operTypesSelect.find((oper) => {
                        return oper.value == el.operator;
                    });
                    if (!condition.oper) {
                        condition.type = 5;
                        condition.oper = this.operTypes.find((oper) => {
                            return oper.value == el.operator;
                        });
                    }
                }
                if (condition.type == 4) {
                    let availArr = this.available.time;
                    if (availArr) {
                        condition.variable = availArr.find((avail) => {
                            return avail.key == el.time.field;
                        });
                    }
                    condition.time = el.time.value;
                    condition.comparison_operator = el.time.comparison_operator;
                }
                this.conditions.push(condition);
            });
            this.conditions = _.orderBy(this.conditions, ["index"]);
            this.$emit('update:conditionsData', this.conditions);
        },
        openAddCondition() {
            this.showConditionForm = true;
        },
        closeAddCondition() {
            this.showConditionForm = false;
            this.editItem = null;
            this.type = null;
            this.updateType();
        },
        addCondition() {
            let condition = {};
            if (this.type) {
                condition.type = this.type;
            }
            if (this.device || this.scenario || this.type == 4) {
                if (this.device) {
                    condition.device = this.device;
                    if (this.trigger) {
                        condition.trigger = this.trigger;
                    }
                }
                if (this.scenario) {
                    condition.scenario = this.scenario;
                }
                condition.variable = this.variable;
                if (this.state || (this.device && this.variable.value_type == 'select' && this.device.device_type == 12)) {
                    condition.state = this.state;
                }
                if (this.number) {
                    condition.number = this.number;
                }
                if (this.time) {
                    condition.time = this.time;
                }
                condition.comparison_operator = this.comparisonOperator ?
                    this.comparisonOperator : this.variable.comparison_operators[0];
            }
            if (this.operRadio) {
                condition.oper = this.operRadio;
            }
            if (this.editItem) {
                let equal = null;
                this.conditions.forEach((el, index) => {
                    if (_.isEqual(this.editItem, el)) {
                        equal = index;
                    }
                });
                if (equal != null) {
                    this.conditions[equal] = condition;
                } else {
                    if (!this.operRadio) {
                        this.checkOpers();
                    }
                    // else if (this.operRadio.value == "(") {
                    //     this.checkOpers();
                    // }
                    this.conditions.push(condition);
                }
            } else {
                if (!this.operRadio) {
                    this.checkOpers();
                }
                // else if (this.operRadio.value == "(") {
                //     this.checkOpers();
                // }
                this.conditions.push(condition);
            }
            if (this.operRadio && this.operRadio.value == "(" && !this.editItem) {
                this.conditions.push({
                    type: 3,
                    oper: this.operTypesSelect[1]
                });
            }
            this.editItem = null;
            this.$emit('update:conditionsData', this.conditions);
            this.closeAddCondition();
        },
        checkOpers(val = 0) {
            let conditionsCount = val;
            let opersCount = 0;
            this.conditions.forEach((el) => {
                if (el.type == 5) {
                    opersCount++;
                } else if (el.type != 3) {
                    conditionsCount++;
                }
            });
            if (opersCount < conditionsCount) {
                this.conditions.push({
                    type: 5,
                    oper: this.operTypes[1]
                });
            }
            else {
                let index = this.conditions.map((el) => {
                    return el.type
                }).reverse().indexOf(5);
                if (index != -1) {
                    this.removeCondition(this.conditions.length - index - 1);
                }
            }
        },
        removeCondition(item) {
            let type = this.conditions[item] ? this.conditions[item].type : null;
            this.conditions.splice(item, 1);
            if (type != 5) {
                this.checkOpers(-1);
            }
            this.$emit('update:conditionsData', this.conditions);
        },
        switchOper(item) {
            this.conditions[item].oper = this.conditions[item].oper && this.conditions[item].oper.value == "or" ?
                this.operTypes[1] : this.operTypes[0];
        },
        editCondition(item) {
            this.editItem = JSON.parse(JSON.stringify(item));
            if (this.editItem.type) {
                this.type = this.editItem.type;
            }
            if (this.editItem.device || this.editItem.scenario || this.editItem.type == 4) {
                if (this.editItem.device) {
                    this.device = this.editItem.device;
                    if (this.editItem.trigger) {
                        this.trigger = this.editItem.trigger;
                    }
                }
                if (this.editItem.scenario) {
                    this.scenario = this.editItem.scenario;
                }
                this.variable = this.editItem.variable;
                if (
                    this.editItem.state ||
                    (this.editItem.device && this.editItem.variable.value_type == 'select' && this.editItem.device.device_type == 12)
                ) {
                    this.state = this.editItem.state;
                }
                if (this.editItem.number) {
                    this.number = this.editItem.number;
                }
                if (this.editItem.time) {
                    this.time = this.editItem.time;
                }
                this.comparisonOperator = this.editItem.comparison_operator;
            }
            if (this.editItem.oper) {
                this.operRadio = this.editItem.oper;
            }
            this.openAddCondition();
        },
        updateState() {
            this.state = null;
            this.number = null;
            this.time = null;
            this.trigger = null;
            this.comparisonOperator = null;
        },
        updateVariable() {
            this.variable = null;
            this.updateState();
        },
        updateType() {
            this.operRadio = null;
            this.device = null;
            this.scenario = null;
            this.updateVariable();
        },
        checkNumber(evt) {
            return isNumber(evt);
        },
        checkStep(item) {
            let open = 0;
            this.conditions.forEach((el, index) => {
                if (index == item) {
                    return;
                }
                if (index < item && el.type == 3) {
                    if (el.oper && el.oper.value == "(") {
                        open++;
                    } else if (el.oper && el.oper.value == ")") {
                        open = open == 0 ? 0 : open - 1;
                    }
                }
            });
            if (this.conditions[item].oper && this.conditions[item].oper.value == ")") {
                open--;
            }
            return 10 * open;
        },
        update() {
            this.$emit('update:conditionsData', this.conditions);
        },
    }
}
</script>

<style lang="scss" scoped>
.btn-grey.v-btn {
    max-width: 94px;
    text-transform: none;
    margin-right: 10px;
}

.btn-gradient.v-btn {
    max-width: 165px;
}

.condition-form {
    width: 100%;
    margin: 0 0 8px 0;

    .v-input.v-text-field {
        background: rgba(255, 255, 255, 0.5) !important;
    }
}

.opers-group.v-input.v-input--selection-controls.v-input--radio-group {
    ::v-deep .v-input__control {
        flex-direction: row !important;

        .v-input__slot .v-input--radio-group__input {
            flex-direction: row !important;

            .v-radio {
                .v-input--selection-controls__input {
                    display: none !important;
                }

                width: 70px;
                margin-right: 8px;
                margin-bottom: 8px;
            }
        }
    }
}

.condition-row {
    background: #F7F7F9;
    border-radius: 30px;
    min-height: 39px;
    font-size: 16px;
    line-height: 19px;
    margin-bottom: 10px;
    align-self: center;

    &:not(:last-child) {
        margin-right: 8px;
    }

    &.oper-block {
        background: #FFF4BC;
    }

    &__elem {
        padding: 10px 24px;
    }
}

.condition-line {
    min-height: 39px;
    font-size: 16px;
    line-height: 19px;
    padding: 2px 0;
    width: calc(100% - 100px);
    display: inline-flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-self: center;
    align-items: center;
    cursor: pointer;

    &.oper-block {
        text-decoration: underline dashed;
        justify-content: center;
    }
}

.comparisons {
    letter-spacing: 0.10em;
    transform: rotateX(45deg);
    color: rgba(255, 132, 132, 1);
}

.draggable-row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 0;
    padding: 0;
}

.v-input.input-form-grey {
    &::v-deep .v-input__control {
        .v-input__slot {
            margin-bottom: 0;
            top: 14px;

            .v-text-field__slot {
                height: 40px;
            }
        }

        .v-text-field__details {
            top: 12px;
            position: relative;
        }
    }

    &.error-field {
        &::v-deep .v-input__control {
            .v-text-field__details {
                top: 12px;
                position: relative;
            }
        }
    }
}
</style>